
import { defineComponent, ref, computed } from "vue";
import Permission from "@/core/config/Permission";
import moment from "moment";
import axios from "@/axios-instance"
import { useRouter } from "vue-router";
import { emitter } from "@/main";

interface Ticket {
    groupPaper: Array<string>;
    englishName: string;
    englishCode: string;
    englishDate: string;
    englishExpire: string;
    paperOrther: string;
    pagerComplement: Array<any>;
    registrationType: string;
    printed: number;
}
interface ProfileT {
    applicantId: string
    fullName: string
    profileCode: string
    studentCode: string
    majorCode: string
    majorName: string
    dateOfBirth: Date
    placeOfBirth: string
    numberId: string
    permanentAddress: string
    contactMobile: string
    email: string
    password: string
}
interface IncludesT {
    hasPhieuThongTinSinhVien: boolean,
    hasPhotoHocba:boolean,
    hasPhotoBangTotNghiepThpt:boolean,
    hasPhotoGiayKhaiSinh:boolean,
    hasPhotoXacNhanDoiTuongUt:boolean,
    has2PhotoCmnd:boolean,
    chungChiTiengAnh: { 
        checked: boolean, 
        certificateName: string,
        examDate: string,
        expiredDate: string,
        score: string
    },
    hasHinhThe: boolean,
    hasGiayKhamSucKhoe: boolean,
    hasTheBHYT: boolean,
    hasGiayNopTien: boolean,
    hoSoKhac: { checked: boolean, value: string }
}
interface itemT {
    name: string
    appointmentDate: string
    checked: boolean
}
interface DataResquest {
    studentProfile: ProfileT,
    includes: IncludesT,
    additionalItems: Array<itemT>,
    engClassPlacementTest: string,
    submissionDate: Date,

    lastModifiedBy: string,
    receiver: string,
    status: string,
    printed: number
}
export default defineComponent({
    name: "customer-details",
    components: {

    },
    data() {
        return {
            header1: 'Tên hồ sơ',
            header2: 'Ngày hẹn',
        }
    },
    props: {
        dataInitial: Object,
        dataReceipt: Object,
    },
    methods: {
        async printAction(){
            if(!this.canPrintTicket) {
                return
            }
            if(this.expiredPromotion && !this.dataReceipt) {
                return
            }
            const groupTemp: Array<string> = this.formData.groupPaper
            let cloneData: DataResquest = {
                studentProfile: {
                    applicantId: this.dataUser.id,
                    fullName: this.dataUser.admissionRegistration.fullName,
                    profileCode: this.dataUser.admissionRegistration.profileCode,
                    studentCode: this.dataUser.studentCode,
                    majorCode: this.dataUser.admissionRegistration.adMajorCode,
                    majorName: this.dataUser.admissionRegistration.adMajorName,
                    dateOfBirth: new Date(this.dataUser.dateOfBirth),
                    placeOfBirth: this.dataUser.placeOfBirth,
                    numberId: this.dataUser.idNumber,
                    permanentAddress: [
                        this.dataUser.permanentAddress, 
                        this.dataUser.permanentWard, 
                        this.dataUser.permanentDistrict, 
                        this.dataUser.permanentProvince
                    ].join(" "),
                    contactMobile: this.dataUser.contactMobile,
                    email: this.dataUser.contactEmail,
                    password: this.dataUser.password,
                },
                includes: {
                    hasPhieuThongTinSinhVien: groupTemp.includes(this.paperOption[0]),
                    hasPhotoHocba: groupTemp.includes(this.paperOption[1]),
                    hasPhotoBangTotNghiepThpt: groupTemp.includes(this.paperOption[2]),
                    hasPhotoGiayKhaiSinh: groupTemp.includes(this.paperOption[3]),
                    hasPhotoXacNhanDoiTuongUt: groupTemp.includes(this.paperOption[4]),
                    has2PhotoCmnd: groupTemp.includes(this.paperOption[5]),
                    chungChiTiengAnh: { 
                        checked: groupTemp.includes(this.paperOption[6]), 
                        certificateName: groupTemp.includes(this.paperOption[6]) ? this.formData.englishName : '',
                        examDate: groupTemp.includes(this.paperOption[6]) ? this.formData.englishDate : '',
                        expiredDate: groupTemp.includes(this.paperOption[6]) ? this.formData.englishExpire : '',
                        score: groupTemp.includes(this.paperOption[6]) ? this.formData.englishCode : '',
                    },
                    hasHinhThe: groupTemp.includes(this.paperOption[9]),
                    hasGiayKhamSucKhoe: groupTemp.includes(this.paperOption[8]),
                    hoSoKhac: { checked: groupTemp.includes(this.paperOption[7]) , value: groupTemp.includes(this.paperOption[7]) ? this.formData.paperOrther : '' },
                    hasTheBHYT: groupTemp.includes(this.paperOption[10]),
                    hasGiayNopTien: groupTemp.includes(this.paperOption[11]),

                },
                additionalItems: this.isPager.includes('paperMore') ? this.formData.pagerComplement
                .filter(e=>{
                    if( e.value && e.date ) {
                        return e
                    }
                })
                .map(e=>{
                    return { name: e.value, appointmentDate: e.date, checked: false}
                }) : [],
                engClassPlacementTest: this.dataUser.englishClassPlacementTestRegistration.registrationType,
                submissionDate: new Date(),

                lastModifiedBy: "",
                receiver: "",
                status: "",
                printed: this.formData.printed ? Number(this.formData.printed) +1 : 1
            }
            if(cloneData){
                await axios.post(`applicationform/upsert`, cloneData)
                .then(({ data }) => {
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
            }
            const routerData = this.router.resolve(`/phieutiepnhanhoso?id=${this.id}`)
            window.open(routerData.href, '_blank');
        },
        async getData(){
            await axios.get(`applicationform/applicant/${this.id}`)
                .then(({ data }) => {
                    // console.log('includes',data)
                    const includes = data.includes
                    if(includes.hasPhieuThongTinSinhVien){
                        this.formData.groupPaper.push(this.paperOption[0])
                    }
                    if(includes.hasPhotoHocba){
                        this.formData.groupPaper.push(this.paperOption[1])
                    }
                    if(includes.hasPhotoBangTotNghiepThpt){
                        this.formData.groupPaper.push(this.paperOption[2])
                    }
                    if(includes.hasPhotoGiayKhaiSinh){
                        this.formData.groupPaper.push(this.paperOption[3])
                    }
                    if(includes.hasPhotoXacNhanDoiTuongUt){
                        this.formData.groupPaper.push(this.paperOption[4])
                    }
                    if(includes.has2PhotoCmnd){
                        this.formData.groupPaper.push(this.paperOption[5])
                    }
                    if(includes.hasTheBHYT){
                        this.formData.groupPaper.push(this.paperOption[10])
                    }
                    if(includes.hasGiayNopTien){
                        this.formData.groupPaper.push(this.paperOption[11])
                    }
                    if(includes.chungChiTiengAnh.checked){
                        this.formData.groupPaper.push(this.paperOption[6])
                        this.formData.englishName = includes.chungChiTiengAnh.certificateName
                        this.formData.englishCode = includes.chungChiTiengAnh.score
                        this.formData.englishDate = includes.chungChiTiengAnh.examDate
                        this.formData.englishExpire = includes.chungChiTiengAnh.expiredDate
                    } else{
                        this.formData.groupPaper.filter(e=>e != this.paperOption[6])
                        this.formData.englishName = ''
                        this.formData.englishCode = ''
                        this.formData.englishDate = ''
                        this.formData.englishExpire = ''
                    }
                    if(includes.hasGiayKhamSucKhoe){
                        this.formData.groupPaper.push(this.paperOption[8])
                    }
                    if(includes.hasHinhThe){
                        this.formData.groupPaper.push(this.paperOption[9])
                    }
                    if(includes.hoSoKhac.checked){
                        this.formData.groupPaper.push(this.paperOption[7])
                        this.formData.paperOrther = includes.hoSoKhac.value
                    }
                    if(data.additionalItems.length){
                        this.isPager.push('paperMore')
                        this.formData.pagerComplement = data.additionalItems.reduce(
                            (prev, current)=> [...prev, { value: current.name, date: current.appointmentDate}], [])
                        this.formData.pagerComplement.push({ name: '', price: 0})
                    }
                    this.formData.printed = data.printed
                })
                .catch(({ response }) => {
                    console.log('err', response)
                });
        },
        checkData(){
            //console.log(this.formData.pagerComplement)
            const item = this.formData.pagerComplement[this.formData.pagerComplement.length-1]
            if(item.value && item.date){
                this.addPager()
            }
        },
        removePager (index){
            if (index !== -1) {
                this.formData.pagerComplement.splice(index, 1)
            }
        },
        addPager() {
            this.formData.pagerComplement.push({
                value: '',
                date: null
            })
        }
    },
    async created() {
        if(this.dataUser.englishClassPlacementTestRegistration){
            this.formData.registrationType = this.dataUser.englishClassPlacementTestRegistration.registrationType
            if(this.dataUser.englishClassPlacementTestRegistration.registrationType == 'english_certificate'){
                this.formData.groupPaper.push(this.paperOption[6])
                const englishCertificate = this.dataUser.englishClassPlacementTestRegistration.englishCertificate
                if(englishCertificate){
                    this.formData.englishName = englishCertificate.certificateName
                    this.formData.englishCode = englishCertificate.score
                    this.formData.englishDate = englishCertificate.examDate
                    this.formData.englishExpire = englishCertificate.expiredDate
                }
            }
        }
        this.getData()
        emitter.on("checkExpiredPromotion", (data: any) => {
            this.expiredPromotion = data
            // console.log('expiredPromotion',this.expiredPromotion)
        });
    },
    setup(props) {
        const dataResquest = ref<DataResquest>()
        const expiredPromotion = ref(false)
        const isPager = ref<string[]>([])
        const router = useRouter()
        const optionCret = ref<any>(['IELTS','TOEFL iBT','TOEIC','APTIS','PES'])
        const dataUser = ref<any>(props.dataInitial)
        const id = ref(props.dataInitial?.id)
        const paperOption = ref([
            "Phiếu thông tin sinh viên có dán ảnh (in từ hệ thống nhập học, theo mẫu của Trường UMT)",
            "Học bạ THPT các lớp 10, 11, 12",
            `Bằng Tốt nghiệp THPT hoặc tương đương (đối với thí sinh tốt nghiệp năm ${new Date().getFullYear() - 1} trở về trước) hoặc Giấy Chứng nhận tốt nghiệp tạm thời (đối với thí sinh tốt nghiệp năm ${new Date().getFullYear()}); `,
            "Căn cước công dân",
            "Giấy khai sinh",
            "Ảnh 3x4",
            "Bản photo chứng chỉ Tiếng Anh:",
            "Giấy khám sức khỏe (theo mẫu được quy định tại Thông tư 32/2023/TT-BYT)",
            "Hồ sơ minh chứng của điều kiện trúng tuyển",
            "Các giấy tờ xác nhận ưu tiên (đối tượng ưu tiên, khu vực ưu tiên - nếu có)",
            "Thẻ BHYT nếu còn hiệu lực sau ngày 30/9/2026 (nếu có)",
            "Giấy nộp tiền/Ủy nhiệm chi hoặc Biên lai chuyển khoản nếu đã đóng học phí qua ngân hàng",
        ])
        const formData = ref<Ticket>({
            groupPaper: [],
            paperOrther: "",
            pagerComplement: [{value: "", date: null}],
            registrationType: "",
            englishName: '',
            englishCode: '',
            englishDate: '',
            englishExpire: '',
            printed: 0
        })
        const formRef = ref<HTMLFormElement | null>(null);
        const rules = ref({
            groupPaper: [
                {
                    required: true,
                    message: "Vui lòng điền trường này",
                    trigger: "change",
                },
            ],
        })
        // Phiếu ĐÃ HỦY -> form chỉ xem (bản ghi lịch sử bất biến)
        const isCancelled = computed(() => (props.dataInitial as any)?.status === 'cancel')
        // NV tiếp nhận giấy tờ ngay khi SV nộp, không đợi xác nhận hoàn tất -> cho Lưu & In phiếu
        // tiếp nhận từ trạng thái "Chờ xác thực" (completed). Hồ sơ đang xử lý/đã hủy vẫn chặn.
        // BE (applicationform/upsert) ghi [TIMELINE] cho ca in khi chưa xác nhận.
        const canPrintTicket = computed(() => ['completed', 'confirmed'].includes((props.dataInitial as any)?.status))
        // Đang "Chờ xác thực" -> báo cho NV biết in bây giờ sẽ được ghi vào lịch sử hồ sơ
        const isPendingConfirm = computed(() => (props.dataInitial as any)?.status === 'completed')
        return {
            isPager,
            router,
            optionCret,
            Permission,
            formRef,
            formData,
            rules,
            paperOption,
            id,
            dataUser,
            dataResquest,
            expiredPromotion,
            isCancelled,
            canPrintTicket,
            isPendingConfirm
        };
    },
});
